import { generateWebsiteSchema, generateMedicalWebPageSchema, generateBreadcrumbSchema } from "~/utils/seo";

interface SEOStructuredDataProps {
  type: 'website' | 'cycle' | 'pregnancy';
  breadcrumbs?: Array<{name: string, url: string}>;
}

export function SEOStructuredData({ type, breadcrumbs }: SEOStructuredDataProps) {
  let schema;
  
  switch (type) {
    case 'website':
      schema = generateWebsiteSchema();
      break;
    case 'cycle':
      schema = generateMedicalWebPageSchema('cycle');
      break;
    case 'pregnancy':
      schema = generateMedicalWebPageSchema('pregnancy');
      break;
    default:
      schema = generateWebsiteSchema();
  }

  const schemas = [schema];
  
  // 添加面包屑导航结构化数据
  if (breadcrumbs && breadcrumbs.length > 1) {
    schemas.push(generateBreadcrumbSchema(breadcrumbs));
  }

  return (
    <>
      {schemas.map((schemaData, index) => (
        <script
          key={index}
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(schemaData)
          }}
        />
      ))}
    </>
  );
}

// 面包屑导航组件
interface BreadcrumbProps {
  items: Array<{name: string, url: string, current?: boolean}>;
}

export function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="mb-4">
      <ol className="flex items-center space-x-2 text-sm text-gray-600">
        {items.map((item, index) => (
          <li key={index} className="flex items-center">
            {index > 0 && (
              <svg
                className="w-4 h-4 mx-2 text-gray-400"
                fill="currentColor"
                viewBox="0 0 20 20"
                aria-hidden="true"
              >
                <path
                  fillRule="evenodd"
                  d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                  clipRule="evenodd"
                />
              </svg>
            )}
            {item.current ? (
              <span className="font-medium text-pink-600" aria-current="page">
                {item.name}
              </span>
            ) : (
              <a
                href={item.url}
                className="hover:text-pink-600 transition-colors"
              >
                {item.name}
              </a>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}